import type { ReactNode } from 'react'
import { useButtonSkin, type ButtonSize, type ButtonVariant } from './buttonSkin'
import './primitives.css'

/**
 * A `Button`'s look on a `<span>` — what a `PremiumGate` `preview` renders in
 * place of the live control (#527, #578).
 *
 * **Contract: presentational only.** It holds no `button`, no link, no
 * `tabindex` and no form control, and takes no handler, so a locked user has
 * nothing to focus, activate or script — `PremiumGate`'s `inert` and event
 * swallow are a backstop that misses change/input, touch, contextmenu and
 * focus. Skin hook, variant and size go through the same `useButtonSkin` as
 * `Button`; `.btn--preview` gives the span a `<button>`'s box and its
 * vertically centred label (a bare span is inline and ignores the hit-target
 * `min-height`). The box match is
 * measured in a browser, not asserted by jsdom. The label is a plain child and is
 * the only prop that varies per caller.
 */
export function ButtonPreview({
  variant,
  size,
  children,
}: {
  variant: ButtonVariant
  size: ButtonSize
  children: ReactNode
}) {
  const skin = useButtonSkin(variant, size, 'btn--preview', undefined)
  return (
    <span className={skin.className} style={skin.style}>
      {children}
    </span>
  )
}
